import styled, { css } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

import { Media } from '../../assets/Mixins.style';

export const Wrapper = styled.div`
  position: relative;
  display: block;
  flex-shrink: 0;
  width: 112px;
  background: ${(props) => props.theme.background};
  overflow-x: hidden;
  overflow-y: auto;
  transition: 0.2s all;

  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }

  &:after {
    position: absolute;
    width: 2px;
    height: auto;
    background: ${(props) => props.theme.backgroundLine};
    right: 0px;
    top: 30px;
    bottom: 30px;
    z-index: +1;
    content: '';

    ${Media.lg`
      display: none;
    `}
  }

  ${(props) =>
    props.isexpanded &&
    css`
      width: 184px;
    `}

  ${Media.lg`
    position: fixed;
    width: 100%;
    right: 0;
    bottom: 0;
    left: 0;
    height: 80px;
    background: ${(props) => props.theme.background};
    border-top: 1px solid ${(props) => props.theme.backgroundLine};
    z-index: 1;
  `}
`;

export const LogoBox = styled.div`
  position: sticky;
  top: 0;
  background: ${(props) => props.theme.background};
  z-index: +1;
`;

export const LogoHolder = styled(RouterLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 76px;
  cursor: pointer;
`;

export const Logo = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  margin: auto;
`;

export const Content = styled.div`
  display: block;

  ${Media.lg`
    width: 100%;
    height: 100%;
    overflow: auto;
    text-align: center;
  `}
`;
export const ContentInner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 30px 0 0 0;
  transition: 0.2s padding;

  ${Media.lg`
    display: inline-flex;
    width: auto;
    flex-direction: row;
    align-items: stretch;
    justify-content: initial;
    padding: 0;
  `}
`;

export const Item = styled(RouterLink)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 60px;
  height: auto;
  margin-bottom: 35px;
  transition: 0.2s all;
  color: ${(props) => props.theme.color};
  flex-shrink: 0;

  ${(props) =>
    props.isexpanded &&
    css`
      margin-bottom: 25px;
    `}

  svg {
    width: 33px;
    height: 33px;

    ${(props) =>
      props.isexpanded &&
      css`
        width: 53px;
        height: 53px;
      `}
  }

  svg,
  path {
    transition: 0.2s all;
    fill: ${(props) => props.theme.color};
  }

  &:hover {
    color: ${(props) => props.theme.colorOnHover};
    svg,
    path {
      fill: ${(props) => props.theme.colorOnHover};
    }

    &:after {
      background: ${(props) => props.theme.backgroundLineOnHover};
    }
  }

  ${(props) =>
    props.active &&
    css`
      color: ${(props) => props.theme.colorOnActive} !important;

      svg,
      path {
        fill: ${(props) => props.theme.colorOnActive} !important;
      }
    `}

  ${(props) =>
    props.disabled &&
    css`
      color: ${(props) => props.theme.colorOnDisabled} !important;
      pointer-events: none;

      svg,
      path {
        fill: ${(props) => props.theme.colorOnDisabled} !important;
      }
    `}

  &:after {
    position: absolute;
    width: 3px;
    height: 60px;
    transition: 0.2s all;
    background: ${(props) => props.theme.backgroundLine};
    border-radius: 3px;
    right: 0px;
    top: 0;
    bottom: 0;
    z-index: +2;
    content: '';

    ${(props) =>
      props.isexpanded &&
      css`
        height: 70px;
      `}

    ${(props) =>
      props.active &&
      css`
        background: ${(props) => props.theme.backgroundLineOnActive} !important;
      `}

    ${(props) =>
      props.disabled &&
      css`
        background: ${(props) =>
          props.theme.backgroundLineOnDisabled} !important;
      `}

    ${Media.lg`
      display: none;
    `}
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  ${Media.lg`
    width: auto;
    margin: 0px 6px;
    padding: 5px;
  `}
`;

export const ItemHolder = styled.i`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  flex-shrink: 0;
  transition: 0.2s all;

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.5;
    `}

  ${Media.lg`
    padding: 0;
  `}
`;

export const ItemTitle = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  transition: 0.2s all;
  font-size: 0;
  font-weight: 600;
  text-align: center;

  ${(props) =>
    props.isexpanded &&
    css`
      font-size: 14px;
    `}

  ${Media.lg`
    font-size: 12px;
    font-weight: 500;
  `}
`;

export const Grow = styled.div`
  flex-grow: 1;
`;

export const Toggler = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 67px;
  height: 67px;
  margin-bottom: 20px;
  margin-left: 6px;
  color: ${(props) => props.theme.color};
  transition: 0.2s color;
  flex-shrink: 0;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colorOnHover};
  }
`;

export const TogglerIcon = styled.i`
  transform: scaleX(1);
  transition: 0.2s transform;
  font-size: 42px;
  user-select: none;

  ${(props) =>
    props.isToggle &&
    css`
      transform: scaleX(-1);
    `}
`;
